
let parentLink = document.querySelector('.nav__parent-link');
let childLink = document.querySelector('.child--desktop');

parentLink.addEventListener('mouseenter', () =>{
  document.querySelector('#MainContent').style.opacity = 0.3
    childLink.classList.add('active');
})
childLink.addEventListener('mouseleave', () =>{
  document.querySelector('#MainContent').style.opacity = 1
    childLink.classList.remove('active');
})
let parentLinkMobile = document.querySelector('.parent-mobile-li');
let childLinkMobile = document.querySelector('.child--mobile');

parentLinkMobile.addEventListener('click', () =>{
    childLinkMobile.classList.toggle('active');
    let mobileLI = document.querySelector('.parent-mobile-li');
    mobileLI.classList.toggle('expanded')
})




// Check if the parent nav element contains a child ul element
let ul = parentLinkMobile.querySelector('ul');
if (ul) {
  // If the parent nav element contains a child ul element, create a new element for the chevron icon
  let chevron = document.createElement('i');
  chevron.classList.add('fa', 'fa-chevron-down'); 
  let chevronRight = document.createElement('i');
  chevronRight.classList.add('fa', 'fa-chevron-right'); 
  
  let parentLinkMobileLink = document.querySelector('.nav__parent-link--mobile')
  // Append the chevron icon to the parent nav element
  if(parentLinkMobile.classList.contains('expanded')){

  parentLinkMobileLink.appendChild(chevronRight)
  }
  else{
    parentLinkMobileLink.appendChild(chevron);
  }

  
}
